import { CallIntelTypes } from '@frontend/api-call-intel';
import { theme } from '@frontend/theme';
import { ChipVariants } from '@frontend/design-system';

export const CALL_INTEL_PMS_WRITEBACK_FF = 'call-intelligence:pms-writeback';
export const CALL_INTEL_TASK_SETTINGS_FF = 'call-intel:task-settings';

export const AI_OFFICE_USER_UUID = '00000000-0000-0000-0000-000000000000';

export enum CIBannerPriorityGroupEnum {
  OVERVIEW_PAGE = 'call-intel-overview-page-banners',
  CALL_INSIGHTS_PANEL = 'call-intel-call-insights-panel-banners',
}

export enum CIBannerEnum {
  TSS_OVERVIEW_BANNER = 'tss-overview-banner',
  TSS_CALL_INSIGHTS = 'tss-call-insights-banner',
  PMS_WRITEBACK_CALL_INSIGHTS = 'pms-writeback-call-insights-banner',
  CALL_INSIGHT_GLOBAL_FEEDBACK = 'call-insight-global-feedback-callout',
}

export const CIBannerPriorityList: Partial<Record<CIBannerPriorityGroupEnum, CIBannerEnum[]>> = {
  [CIBannerPriorityGroupEnum.OVERVIEW_PAGE]: [CIBannerEnum.TSS_OVERVIEW_BANNER],
  [CIBannerPriorityGroupEnum.CALL_INSIGHTS_PANEL]: [
    CIBannerEnum.PMS_WRITEBACK_CALL_INSIGHTS,
    CIBannerEnum.TSS_CALL_INSIGHTS,
    CIBannerEnum.CALL_INSIGHT_GLOBAL_FEEDBACK,
  ],
};

export const CI_DATE_FORMATS = {
  FULL_TIMESTAMP: 'MMM D, YYYY, h:mm A',
  DATE: 'MMM D, YYYY',
};

export const CALL_INSIGHT_GLOBAL_FEEDBACK_FF = 'call-insight-global-feedback';
export const CALL_INSIGHT_PANEL_V2_FF = 'call-insight-panel-v2';

export const FeedbackFeature = {
  [CallIntelTypes.FeedbackFeatureEnum.FEATURE_CALL_INTELLIGENCE]:
    CallIntelTypes.FeedbackFeatureEnum.FEATURE_CALL_INTELLIGENCE,
  [CallIntelTypes.FeedbackFeatureEnum.FEATURE_AI_RECEPTIONIST]:
    CallIntelTypes.FeedbackFeatureEnum.FEATURE_AI_RECEPTIONIST,
  [CallIntelTypes.FeedbackFeatureEnum.FEATURE_OTHER]: CallIntelTypes.FeedbackFeatureEnum.FEATURE_OTHER,
  FEATURE_NETWORK_PERFORMANCE: 'FEATURE_NETWORK_PERFORMANCE',
} as const;

export type FeedbackFeatureType = keyof typeof FeedbackFeature;

export const FeedbackFeatureSubIssueMap: Record<keyof typeof FeedbackFeature, CallIntelTypes.FeedbackSubIssueEnum[]> = {
  [FeedbackFeature.FEATURE_CALL_INTELLIGENCE]: [
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_CALL_SUMMARY_LOW_PRECISION,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_CALL_TRANSCRIPT_LOW_PRECISION,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_FOLLOWUP_TASKS_UNNECESSARY,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_CONTACT_TYPE_MISLABELLED,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_CALL_SENTIMENT_MISLABELLED,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_SERVICE_ISSUES_MISLABELLED,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_SCHEDULING_OUTCOME_MISLABELLED,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_CALL_CATEGORY_MISLABELLED,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_APPOINTMENT_TYPE_MISLABELLED,
    CallIntelTypes.FeedbackSubIssueEnum.SUB_ISSUE_OTHER,
  ],
  [FeedbackFeature.FEATURE_AI_RECEPTIONIST]: [],
  [FeedbackFeature.FEATURE_NETWORK_PERFORMANCE]: [],
  [FeedbackFeature.FEATURE_OTHER]: [],
};

export const variantBackgroundMap: Record<ChipVariants, string> = {
  primary: theme.colors.primary10,
  critical: theme.colors.critical10,
  success: theme.colors.success10,
  warn: theme.colors.warning5,
  active: theme.colors.warning5,
  eggplant: theme.colors.secondary.eggplant10,
  seaweed: theme.colors.secondary.seaweed10,
  disabled: theme.colors.neutral10,
  interactive: 'transparent',
  neutral: theme.colors.neutral10,
  outline: 'transparent',
  default: theme.colors.neutral5,
  primaryDark: theme.colors.primary20,
  warningDark: theme.colors.warning50,
  warningNeutral: theme.colors.warning20,
  indigo: theme.colors.indigo10,
  tangerine: theme.colors.tangerine10,
  rose: theme.colors.rose10,
};
